module.exports = __webpack_public_path__ + "static/img/concepSymbol.2419328b.png";